/**
 * If the ratio value of each sizes is below this, then it will be Size Ratio or Else it will be Size Breakup
 */
export const CutOffSizeRatio = 5;

export const LocaleId = {
  Hindi: "hi",
  English: "en",
  Tamil: "ta",
  Kannada: "kn",
  Telugu: "te",
  Bangla: "bn",
  Malayalam: "ml",
  Marathi: "mr"
};

export const Locale = {
  hi: "Hindi",
  en: "English",
  ta: "Tamil",
  kn: "Kannada",
  te: "Telugu",
  bn: "Bangla",
  ml: "Malayalam",
  mr: "Marathi"
};

export const Role = {
  MASTER: "master",
  SUPER_USER: "super_user",
  ADMIN_USER: "admin",

  //** New Roles in V5 **//
  IT: "it",
  MONITORING: "monitor",
  DATA_ENTRY_MANAGEMENT: "data_entry",
  PPC: "ppc",
  FABRIC_STORE_MANAGEMENT: "fabric_store",
  FABRIC_QUALITY_MANAGEMENT: "fabric_quality",
  PATTERN_MASTER: "pattern_master",
  CUT_PLANNER: "cut_planner",
  EST_CAD: "est_cad",
  MERCHANT: "merchant",
  CUTTING_IN_CHARGE: "cutting_incharge",
  FABRIC_SPREADER: "spreader",
  PANEL_RECUTTING: "panel_recut",

  //** Old Roles before V5 **//
  // MERCHANT: "merchant",
  WAREHOUSE: "warehouse",
  // PATTERN_MASTER: "pattern_master",
  CAD: "cad",
  CUTTING: "cutting",
  ADMINISTRATOR: "administrator"
};

/**
 * @deprecated use value from setting
 */
export const garments = {
  JACKET_AND_WAIST_COAT_AND_TROUSER: "3 Piece Suit",
  JACKET_AND_TROUSER: "2 Piece Suit",
  TROUSER: "Trouser",
  WAIST_COAT: "Waist Coat",
  JACKET: "Jacket",
  JACKET_AND_WAIST_COAT: "Jacket + Waist Coat",
  WAIST_COAT_AND_TROUSER: "Waist Coat + Trouser"
};

export const QcStatus = {
  PENDING: "Pending",
  PASS: "Pass",
  FAIL: "Fail",
  ON_HOLD: "On Hold"
};

export const SyncStatus = {
  PENDING: "Pending",
  COMPLETED: "Completed",
  QC_COMPLETED: "QC Completed",
  PASS: "Pass",
  Fail: "Fail",
  IN_SYNC: "In-Sync",
  RE_QC: "Re-QC",
  NOT_SYNCED: "Not Synced",
  NOT_IN_SYNC: "Not In-Sync"
};

export const InventoryStatus = {
  UNALLOCATED: "Unallocated",
  ALLOCATED: "Allocated",
  PLANNED: "Planned",
  ISSUED: "Issued",
  USED: "Used",
  RETURNED: "Returned",
  WRITE_OFF: "Write-Off",
  OUTSOURCED: "Outsourced",
  NOT_PLANNED: "Not Planned",
  DISABLED: "Disabled"
};

export const CSV = {
  NO: "No",
  YES: "Yes",
  GRADE3: "Grade 3",
  GRADE34: "Grade 3-4",
  GRADE4: "Grade 4"
};

export const ChecklistType = {
  COSTING: "Costing",
  ESTIMATION: "Estimation"
};

export const LedgerType = {
  IN: "IN",
  OUT: "OUT",
  WH_TRANSFER: "WH_TRANSFER",
  ITEM_TRANSFER: "ITEM_TRANSFER"
};

export const RollType = {
  NORMAL: "NORMAL",
  EXTRA: "EXCESS",
  MISSING: "MISSING",
  REJECTED: "REJECTED"
};

export const RollReturnTxnType = {
  RETURN: "RETURN",
  MISSING: "MISSING"
};

export const ReturnStatus = {
  RETURNED: "Returned",
  MISSED: "Missed",
  CONFIRMED: "Confirmed"
};

export const GroupType = {
  SHRINKAGE: "SHRINKAGE",
  FINAL: "FINAL"
};

export const SpreadingType = {
  FACE_ONE_WAY: "Face one Way",
  FACE_TO_FACE: "Face to Face",
  BACK_TO_BACK: "Back to Back"
};

export const MarkerType = {
  FINAL: "FINAL",
  REMNANT: "REMNANT",
  REMNANT_RETAINED: "REMNANT_RETAINED",
  MANUAL: "MANUAL",
  RE_CUTTING: "RE_CUTTING"
};

export const LayType = {
  ALL_MIX: "All Mix",
  SHADE_WISE: "Shade Wise",
  COLOR_WISE: "Color Wise",
  RECUTTING: "Recutting"
};

export const ReserveType = {
  ACROSS_GROUPS: "Across Groups",
  PER_ROLL_FIXED: "Per Roll (Fixed)",
  PER_ROLL_DYNAMIC: "Per Roll (Dynamic)",
  SOFTWARE: "Software"
};

export const EstimationState = {
  NEW: "New",
  PENDING: "Pending",
  AVAILABLE: "Available",
  COMPLETED: "Completed"
};

export const EstimationStateValue = {
  New: 0,
  Pending: 1,
  Available: 2,
  Completed: 3
};

export const OState = {
  PART_DETAIL_PENDING: { state: "Part Detail Pending", stateValue: 0 },
  NEW: { state: "New", stateValue: 1 },

  FABRIC_ASSOCIATED: { state: "Fabric Associated", stateValue: 2 },
  GRN_COMPLETED: { state: "GRN Completed", stateValue: 3 },
  FABRIC_QC_IN_PROGRESS: { state: "Fabric QC In Progress", stateValue: 4 },
  FABRIC_QC_COMPLETED: { state: "Fabric QC Completed", stateValue: 5 },
  FABRIC_ALLOCATED: { state: "Fabric Allocated", stateValue: 6 },

  SHRINKAGE_GROUPING_COMPLETED: { state: "Shrinkage Grouping Completed", stateValue: 7 },
  FINAL_GROUPING_COMPLETED: { state: "Final Grouping Completed", stateValue: 8 },

  MAIN_CUTPLAN_GENERATED: { state: "Main Cut Plan Generated", stateValue: 9 },
  MAIN_CUTPLAN_COMPLETED: { state: "Main Cut Plan Completed", stateValue: 10 },
  REMNANT_CUTPLAN_COMPLETED: { state: "Remnant Cut Plan Completed", stateValue: 11 },

  CUTPLAN_IN_PROGRESS: { state: "Cut Plan In Progress", stateValue: 12 },
  CUTPLAN_COMPLETED: { state: "Cut Plan Completed ", stateValue: 13 },

  ROLL_PLAN_GENERATED: { state: "Roll Plan Generated", stateValue: 14 },

  MAIN_FEEDBACK_IN_PROGRESS: { state: "Main Feedback In Progress", stateValue: 15 },
  MAIN_FEEDBACK_COMPLETED: { state: "Main Feedback Completed", stateValue: 16 },

  RE_PLANNING_IN_PROGRESS: { state: "Re-Planning In Progress", stateValue: 17 },
  RE_PLANNING_COMPLETED: { state: "Re-Planning Completed", stateValue: 18 },

  REMNANT_FEEDBACK_IN_PROGRESS: { state: "Remnant Feedback In Progress", stateValue: 19 },
  REMNANT_FEEDBACK_COMPLETED: { state: "Remnant Feedback Completed", stateValue: 20 },

  FEEDBACK_IN_PROGRESS: { state: "Feedback In Progress ", stateValue: 21 },
  FEEDBACK_COMPLETED: { state: "Feedback Completed ", stateValue: 22 },

  BUNDLING_PENDING: { state: "Bundling Pending", stateValue: 23 },
  BUNDLING_IN_PROGRESS: { state: "Bundling In Progress", stateValue: 24 },
  BUNDLING_IN_COMPLETED: { state: "Bundling Completed", stateValue: 25 },

  FPO_SPLIT_PENDING: { state: "FPO Split Pending", stateValue: 26 },
  FPO_SPLIT_IN_PROGRESS: { state: "FPO Split In Progress", stateValue: 27 },
  FPO_SPLIT_COMPLETED: { state: "FPO Split Completed", stateValue: 28 },

  CLOSURE_CONFIRMATION_PENDING: { state: "Closure Confirmation Pending", stateValue: 29 },
  CLOSED: { state: "Closed", stateValue: 30 }
};

export const EstimationStage = {
  TENTATIVE: "Tentative",
  FINAL: "Final"
};

export const AlertParemeter = {
  CUT_PLAN_QTY: { id: "cutPlanQty", name: "Cut Plan Quantity" },
  CONSUMPTION_VARIATION: { id: "consumptionVariation", name: "Consumption Variation" },
  MARKER_EFFICIENCY_VARIATION: { id: "markerEfficiencyVariation", name: "Marker Efficiency Variation" },
  CUTTABLE_WIDTH_VARIATION: { id: "cuttableWidthVariation", name: "Cuttable Width Variation" },
  GSM_VARIATION: { id: "gsmVariation", name: "GSM Variation" },
  CSV_VARIATION: { id: "csvVariation", name: "CSV Variation" },
  WARP_SHRINKAGE_VARIATION: { id: "warpShrinkageVariation", name: "Shrinkage- Warp/Length Variation" },
  WEFT_SHRINKAGE_VARIATION: { id: "weftShrinkageVariation", name: "Shrinkage- Weft/Width Variation" }
};

export const AlertParameterImpact = {
  INCREASE: "Increase",
  DECREASE: "Decrease"
};

export const FabricDirection = {
  TwoWay: "Two Way",
  OneGarmentOneWay: "One Garment One Way",
  AllGarmentOneWay: "All Garment One Way"
};

export const TaskState = {
  NEW: "New",
  WAITING: "Waiting",
  RUNNING: "Running",
  COMPLETED: "Completed",
  FAILED: "Failed",
  CANCELLED: "Cancelled"
};

export const TaskNames = {
  CUT_PLAN_GENERATE: "cutplan:generate",
  CUT_PLAN_MAIN_MARKER_UPDATE: "cutplan:main-marker-update",
  CUT_PLAN_REMNANT_MARKER_UPDATE: "cutplan:remnant-marker-update",
  CUT_PLAN_ADJUST: "cutplan:adjust",
  CUT_PLAN_MARRY: "cutplan:marry",
  CUT_PLAN_RE_GENERATE: "cutplan:re-generate"
};

export const DataType = {
  TEXT: "text",
  NUMBER: "number",
  BOOLEAN: "boolean",
  SELECT: "select",
  DATE: "date"
};

export const Entity = {
  ORDERS: "orders",
  FLOW_INFO: "flowInfo",
  ORDER_FLOW: "orderFlow",
  FABRICS: "fabrics",
  INVOICES: "invoices",
  FABRIC_ITEMS: "fabricItems",
  ROLLS: "rolls",
  LAYS: "lays",
  USERS: "users"
};
